import { Box, styled } from '@mui/material';

/** 레거시 마크업의 정렬 클래스만 보충 — 열 폭은 colgroup 합이라 좁은 화면에선 표가 가로 스크롤 */
export const ShopManagerFeeRoot = styled(Box)`
  & .text-center {
    text-align: center;
  }

  & .text-center td.text-left {
    text-align: left;
  }
`;
